import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";

import { Dimensions } from 'react-native'
import React from "react";
import { switchScreen } from "@/hooks/navigate";
import CancelButton from "@/components/basic/CancelButton";
import BasicButton from "@/components/basic/BasicButton";
import i18n from "i18n-js";
import { useSelector } from "react-redux";

export default function ModalFcm({ route, navigation }) {
    /** @type {{ type: NotificationType, id: string }} */ const params = route.params;
    const { type, id } = params;
    const object = ["newCopy", "newShare", "plannerEvent"].includes(type)
        ? useSelector(state => Object.entries(state.workflows).find(([key, item]) => item.workflowId === id))
        : undefined;

    const { width: screenWidth } = Dimensions.get('window');

    const handleRouting = () => {
        let key, workflow;
        if (object){
              [key, workflow] = object;
        }
        switch (type) {
            case "contactRequest": {
                navigation.replace('ContactManagement')
                break;
            }
            case "plannerRequest": {
                navigation.replace('Contacts', { isPlanner: true, isFinal: false })
                switchScreen(navigation, 'PlannerRequests')
                break;
            }
            case "newCopy":
            case "newShare": {
                navigation.replace("Workflows")
                switchScreen(navigation, 'ShowWorkflow2', {taskid: key, isLoading: false})
                break;
            }
            case "plannerEvent":{
                navigation.replace("ShowWorkflow", {taskid: key})
            }
        }
    }

    const handleTitle = () => {
        switch (type) {
            case 'contactRequest':
            case "plannerEvent":
            case "newShare":
            case "plannerRequest":
            case "newCopy":
                return `modalFcm.${type}`
            default:
                switchScreen(navigation, 'BACK') // sorgt dafür das wenn falsche daten vorhanden, sich das modal direkt schließt
        }
    }

    const handleGoToText = () => {
        switch (type) {
            case "plannerRequest":
                return 'modalFcm.goToPlannerRequests';
            case "contactRequest":
                return 'modalFcm.goToContacts';
            case "plannerEvent":
            case "newCopy":
            case "newShare":
                return 'modalFcm.goToWorkflow'
        }
    }

   return (
       <View className="flex-1 bg-[#00000050] justify-center">
           <VStack space='md' className={` width-${0.95*screenWidth} m-3 bg-secondary-50 px-4 py-5 rounded-[5px] max-w-[480px] self-center `}>
               <Text bold className="text-2xl text-secondary-900 bg-secondary-50 py-2">{i18n.t(handleTitle())}</Text>
               <VStack space='sm' className="pt-3">
                   <BasicButton onPress={() => { handleRouting() }} text={i18n.t(handleGoToText())} />
                   <CancelButton onPress={() => { switchScreen(navigation, 'BACK')}} text={i18n.t('message.back')} />
               </VStack>
           </VStack>
       </View>
   );
}
